import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
// Fix video playback in low battery mode
document.addEventListener('DOMContentLoaded', function() {
  const heroSection = document.querySelector('.hero');
  
  if (heroSection) {
    const heroVideo = heroSection.querySelector('.hero__video');
    
    if (heroVideo) {
      // Enable pointer events so video can be clicked
      const mediaWrapper = heroSection.querySelector('.hero__media-wrapper');
      if (mediaWrapper) {
        mediaWrapper.style.pointerEvents = 'auto';
      }
      
      // Make video clickable to play
      heroVideo.style.pointerEvents = 'auto';
      heroVideo.addEventListener('click', function() {
        if (heroVideo.paused) {
          heroVideo.play();
        }
      });
    }
  }
});
